import React, {useContext, useRef, useState} from 'react';

// import API from '../../services/api';
import AuthContext from '../../components/shared/AuthContext';
import {Link, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import LangSwitcher from '../../components/langSwitcher';


import Swal from 'sweetalert2';
import OrgContext from '../../organisation/OrgContext';

import LoginBg from '../../assets/images/login/login_bg.png';
import  LOginTitleBg from '../../assets/images/login/login_title_bg.png';
import LogoElManager from '../../assets/images/login/elmanager_logo_square.png';
import LoginHero from '../../assets/images/login/hero_login.png';
import './login.css';

function Login(props) {

    const [t, i18n] = useTranslation();

    const {changeOrg} = useContext(OrgContext);

    const [showPass, setShowPass] = useState(false);

    const userName = useRef("");
    const password = useRef("");
    const {login, setUser} = useContext(AuthContext);

    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(false);

    const loginSubmit = async (event) => {
        event.preventDefault();
        if (
            userName.current.value.trim().length > 0
            && password.current.value.trim().length > 0
        ) {
            try {
                let payload = {

                    email: userName.current.value,
                    password: password.current.value
                }

                const response = await login(payload);
                if (response.data.user) {
                    if (response.data.user.is_active == 1) {
                        localStorage.setItem("tokens", JSON.stringify(response.data));
                        if (response.data.organisations) {
                            if (response.data.organisations.length > 0) {
                                if (!localStorage.getItem("orgs")) {
                                    changeOrg(response.data.organisations[0]);
                                }
                            } else {
                                setUser(response.data.user);
                                navigate("/organisation_profile");
                                window.location.reload();
                                return;
                            }
                        }
                        setUser(response.data.user);
                        window.location.reload();
                    } else {
                        setIsActive(true);
                    }

                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: '',
                        text: t('Something went wrong!, try again'),
                    });
                }

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        } else {
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Field email and password should be not empty'),
            });
        }

    };

    const showPassword = (event) => {
        event.preventDefault();
        setShowPass(!showPass);
    }


    return (
        <div className="login-split">
            {/* Left: hero image */}
            <div className="login-split__hero">
                <img src={LoginHero} alt="ELMANAGER - Simplifiez votre gestion financière" />
            </div>

            {/* Right: login form */}
            <div className="login-split__panel">
                <div className="login-split__form-wrap">
                    <center>
                        <a className="login-split__logo" href="http://www.elmanager.ma">
                            <img src={LogoElManager} alt="ELMANAGER"/>
                        </a>
                    </center>

                    {isActive ? (
                        <div className="login-split__notice">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" height="60" width="60"
                                     viewBox="0 0 24 24"><path fill="#13bfa6"
                                     d="M10.3125,16.09375a.99676.99676,0,0,1-.707-.293L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328l-6.1875,6.1875A.99676.99676,0,0,1,10.3125,16.09375Z"
                                     opacity=".99"></path><path
                                    fill="#71d8c9"
                                    d="M12,2A10,10,0,1,0,22,12,10.01146,10.01146,0,0,0,12,2Zm5.207,7.61328-6.1875,6.1875a.99963.99963,0,0,1-1.41406,0L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328Z"></path></svg>
                            </span>
                            <h4>Succès</h4>
                            <p>{t("Votre compte a été créé avec succès, veuillez patienter lorsque l'administrateur active votre compte, et vous pouvez vous connecter au tableau de bord")}</p>
                            <button
                                type="button"
                                onClick={() => setIsActive(false)}
                                className="login-split__submit">{t("Fermer")}</button>
                        </div>
                    ) : (
                        <>
                            <h1 className="login-split__title">Bienvenue sur Elmanager</h1>
                            <p className="login-split__subtitle">Connectez-vous à votre espace de gestion commerciale et comptable.</p>

                            <form className="login-split__form" onSubmit={loginSubmit}>
                                <div className="login-split__field">
                                    <label htmlFor="email" className="login-split__label">
                                        {t("Your Email")}<span className="text-danger"> *</span>
                                    </label>
                                    <input id="email" type="email" className="login-split__input"
                                           name="email" required ref={userName} placeholder={"Email"}/>
                                </div>

                                <div className="login-split__field">
                                    <label htmlFor="password" className="login-split__label">
                                        {t("Password")}<span className="text-danger"> *</span>
                                    </label>
                                    <div className="login-split__input-wrap">
                                        <input id="password" ref={password}
                                               type={!showPass ? "password" : "text"}
                                               className="login-split__input login-split__input--password"
                                               name="password" required placeholder={"Mot de passe"}/>
                                        <button type="button" onClick={showPassword}
                                                className="login-split__eye"
                                                aria-label={showPass ? "Masquer" : "Afficher"}>
                                            {!showPass ?
                                                <i className="zmdi zmdi-eye-off" aria-hidden="true"></i> :
                                                <i className="zmdi zmdi-eye" aria-hidden="true"></i>}
                                        </button>
                                    </div>
                                    <div className="login-split__meta">
                                        <Link className="login-split__forgot" to="/reset_password">
                                            {t("Forgot Password?")}
                                        </Link>
                                    </div>
                                </div>

                                <button type="submit" className="login-split__submit">
                                    {t("Se connecter")}
                                </button>
                            </form>

                            <div className="login-split__secure-alert" role="note">
                                <i className="zmdi zmdi-shield-check" aria-hidden="true"></i>
                                <div className="login-split__secure-text">
                                    <strong>{t("Vos données professionnelles, en toute sécurité")}</strong>
                                    <p>{t("Elmanager Cloud protège vos informations et vos données grâce à des mécanismes de sécurité adaptés à votre activité.")}</p>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Login;

